import { Dialog } from '@reach/dialog';
import VisuallyHidden from '@reach/visually-hidden';
import React, { useState } from 'react';
import { SpRelic } from '../domain/relic';
import Button from './Button';
import './dialog-styles.css';
import Input from './Input';
import RelicIcon from './RelicIcon';

interface Props {
    showDialog: boolean,
    onSubmit: (relic: SpRelic) => void,
    onClose: () => void,
}

const AddRelicDialog: React.FC<Props> = ({
    showDialog,
    onSubmit,
    onClose
}) => {
    const [name, setName] = useState('');
    const [person, setPerson] = useState('');
    const submit = () => {
        if (!!name && !!person) {
            onSubmit({ name, person });
            onClose();
        }
    }

    return showDialog ? (<Dialog onDismiss={onClose} aria-label="Add Relic Dialog" className="relative max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl">
        <button className="absolute right-0 top-0 h-10 w-10 bg-gray-300" onClick={onClose}>
            <VisuallyHidden>Close</VisuallyHidden>
            <span aria-hidden>×</span>
        </button>
        <form className="grid gap-2 grid-cols-relic-dialog">
            <RelicIcon name={name} className="col-start-1 col-end-2 row-start-1 row-end-3 w-16 h-16" />
            <Input
                type="text"
                className="col-start-2 col-end-3 row-start-1 row-end-2"
                placeholder="My favourite book 📖"
                value={name}
                onChange={setName}
            />
            <Input
                type="text"
                className="col-start-2 col-end-3 row-start-2 row-end-3"
                placeholder="The person I love"
                value={person}
                onChange={setPerson}
            />
            <Button
                className="col-start-1 col-end-3 row-start-3 row-end-4"
                type="button"
                onClick={submit}
            >Submit</Button>
        </form>
    </Dialog>) : null;
}

export default AddRelicDialog;
